<ion-item class="header" [color]="color" lines="none"
    [ngStyle]="{ '--min-height': height, 'border-bottom': lines ? '3px solid var(--ion-color-' + lines + ')' : 'none' }"
    [ngClass]="{ 'mobile': view.Mobile, 'light': view.LightTheme }">
    <ion-buttons class="menu-icon" *ngIf="ShowMenu" slot="start" >
        <ion-menu-button uppDataid="main-menu-button" auto-hide="true"></ion-menu-button>
    </ion-buttons>
    <ng-content select="upp-header-title"></ng-content>
    <ng-content select="upp-header-content"></ng-content>
    <ion-buttons slot="end">
        <ng-content></ng-content>
    </ion-buttons>
</ion-item>